module.exports = __webpack_public_path__ + "img/42babc28659cd49898fea67dc27951e9.png";